import filter from 'lodash/filter'
import groupBy from 'lodash/groupBy'
import { useMemo } from 'react'
import { angebote_data } from '../data/angebote_data'
import { stripQuarters } from './helperFunctions'
import type { RegionBarGraphData } from './typings'
import { useRegressionLineForData } from './useRegressionLineForData'

export const useDataForRegionBarGraph = (
  region: string
): RegionBarGraphData[] => {
  const preparedData = useMemo(() => {
    const filteredForRegion = filter(angebote_data, (d) => d.name === region)
    const strippedQuarters = stripQuarters(filteredForRegion)
    const groupedByYear = groupBy(strippedQuarters, 'zeit')
    const summedByYear: RegionBarGraphData[] = Object.keys(groupedByYear).map(
      (year) => {
        const dataForYear = groupedByYear[year]
        const summed_angebote_kauf = dataForYear.reduce(
          (acc, cur) => acc + cur._angebote_kauf,
          0
        )
        const summed_angebote_miete = dataForYear.reduce(
          (acc, cur) => acc + cur._angebote_miete,
          0
        )
        return {
          id: parseInt(year),
          Kauf: summed_angebote_kauf,
          Miete: summed_angebote_miete,
        } as RegionBarGraphData
      }
    )
    return summedByYear
  }, [region])

  const regressionLineValues_kauf = useRegressionLineForData(
    'Kauf',
    preparedData
  )
  const regressionLineValues_miete = useRegressionLineForData(
    'Miete',
    preparedData
  )

  const finalData = useMemo(() => {
    return preparedData.map(
      (d, i) =>
        ({
          ...d,
          lineValueKauf: regressionLineValues_kauf[i],
          lineValueMiete: regressionLineValues_miete[i],
        } as RegionBarGraphData)
    )
  }, [preparedData, regressionLineValues_kauf, regressionLineValues_miete])

  return finalData
}
